import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useSnoozeStore = defineStore('snooze', () => {
  const clusterId = ref<number | string>()
  const isShowSnoozeDialog = ref(false)

  const showSnoozeDialog = (clickedClusterId: number | string): void => {
    clusterId.value = clickedClusterId
    isShowSnoozeDialog.value = true
  }

  return {
    clusterId,
    isShowSnoozeDialog,
    showSnoozeDialog
  }
})
